import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { storage2Service } from 'services/storage2Service';
import { parseApiError } from 'utils/errorParser';

export const fetchStorage2 = createAsyncThunk('storage2/fetch', async (params, { rejectWithValue }) => {
  try {
    return await storage2Service.list(params);
  } catch (error) {
    return rejectWithValue(parseApiError(error));
  }
});

const storage2Slice = createSlice({
  name: 'storage2',
  initialState: { items: [], status: 'idle', error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStorage2.pending, (state) => { state.status = 'loading'; })
      .addCase(fetchStorage2.fulfilled, (state, action) => { state.status = 'succeeded'; state.items = action.payload; })
      .addCase(fetchStorage2.rejected, (state, action) => { state.status = 'failed'; state.error = action.payload?.message; });
  },
});

export default storage2Slice.reducer;
